import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { Collapse, makeStyles } from "@material-ui/core";
import { useInView } from "react-intersection-observer";
import { color, motion } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import instantChatIcon1 from "../../images/v4/linkGeneration/icons/instantChatIcon1.svg";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";

import whiteCheckCircle from "../../images/v4/whatsappPage/icons/whiteCheckCircle.svg";
import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";
import darkGreenCheck from "../../images/v4/industry/education/icons/darkGreenCheck.svg";

import partnerIcon1 from "../../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../../images/v4/aiPage/icons/partnerIcon8.png";

import transformBackgroundImage from "../../images/v4/linkGeneration/images/transformBackgroundImage.png";

import partnerSectionBackground from "../../images/v4/linkGeneration/images/partnerSectionBackground.png";

import bestPracticeIcon1 from "../../images/v4/industry/manufacture/icons/bestPracticeIcon1.svg";
import bestPracticeIcon2 from "../../images/v4/industry/manufacture/icons/bestPracticeIcon2.svg";
import bestPracticeIcon3 from "../../images/v4/industry/manufacture/icons/bestPracticeIcon3.svg";
import bestPracticeIcon4 from "../../images/v4/industry/manufacture/icons/bestPracticeIcon4.svg";
import bestPracticeIcon5 from "../../images/v4/industry/manufacture/icons/bestPracticeIcon5.svg";
import bestPracticeIcon6 from "../../images/v4/industry/manufacture/icons/bestPracticeIcon6.svg";

import gridIcon1 from "../../images/v4/industry/manufacture/icons/gridIcon1.svg";
import gridIcon2 from "../../images/v4/industry/manufacture/icons/gridIcon2.svg";
import gridIcon3 from "../../images/v4/industry/manufacture/icons/gridIcon3.svg";
import gridIcon4 from "../../images/v4/industry/manufacture/icons/gridIcon4.svg";
import gridIcon5 from "../../images/v4/industry/manufacture/icons/gridIcon5.svg";
import gridIcon6 from "../../images/v4/industry/manufacture/icons/gridIcon6.svg";
import gridIcon7 from "../../images/v4/industry/manufacture/icons/gridIcon7.svg";

import bestPracticeBg from "../../images/v4/industry/education/images/bestPracticeBg.png";
import industryHeroSectionBg from "../../images/v4/industry/education/images/industryHeroSectionBg.png";

import compareItemImg1 from "../../images/v4/industry/education/images/compareItemImg1.png";
import compareItemImg2 from "../../images/v4/industry/manufacture/images/compareItemImg2.png";
import compareItemImg3 from "../../images/v4/industry/manufacture/images/compareItemImg3.png";
import compareItemImg4 from "../../images/v4/industry/manufacture/images/compareItemImg4.png";
import compareItemImg5 from "../../images/v4/industry/manufacture/images/compareItemImg5.png";

import featureSectionImg from "../../images/v4/industry/manufacture/images/featureSectionImg.png";
import meaningImg from "../../images/v4/industry/manufacture/images/meaning.png";
import benifitImg from "../../images/v4/industry/manufacture/images/benifitImg.png";
import bodySectionBg from "../../images/v4/industry/education/images/bodySectionBg.png";

import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";
import SEO from "../../components/SEO";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    background: `url(${industryHeroSectionBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    padding: "90px 0 220px",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "10px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
      "& .buttonContaienr": {
        justifyContent: "center",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
        marginTop: "0px",
        "& .buttonContaienr": {
          alignItems: "center",
        },
        "& .primaryButton": {
          width: "100%",
        },
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "0",
      paddingBottom: "300px",
    },
  },
  listContainer: {
    display: "flex",
    marginTop: "16px",
    // flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minWidth: "100%",
      gap: "15px",
    },
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    border: "1px solid #00B661",
    borderRadius: "50px",
    padding: "10px 15px",
    minWidth: "max-content",
    "@media only screen and (max-width: 600px)": {
      minWidth: "90%",
    },
    // color: "#A2BED3",
  },
  supportBox: {
    top: "100%",
    width: "100%",
    display: "flex",
    padding: "40px",
    background: "linear-gradient(0deg, #401960 0%, #9E5AD5 100%)",
    position: "relative",
    alignItems: "center",
    borderRadius: "20px",
    backdropFilter: "blur(30px)",
    justifyContent: "space-between",
    "& $broadcastLeftContainer": {
      width: "55%",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      width: "94%",
      padding: "15px",
      marginTop: "20px",
      gap: "20px",
    },
  },
  pointers: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
    },
  },
  broadcastLeftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "60%",
    gap: "32px",
    textAlign: "left",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "20px",
    },
  },
  broadcastRightContainer: {
    width: "40%",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  broadcastImg: {
    "& img": {
      width: "100%",
      position: "relative",
      bottom: "0",
    },
  },
  pills: {
    display: "flex",
    width: "100%",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "10px",
    // marginTop: "25px",
  },
  pill: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: "10px 16px",
    borderRadius: "30px",
    border: "1px solid #CEE9FF",
    gap: "10px",
    "@media only screen and (max-width: 600px)": {
      padding: "10px 15px",
      "& img": {
        width: "20px",
      },
    },
  },
  experienceContainerHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    "& h2": {
      width: "55%",
    },
    "& p": {
      width: "45%",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "20px",
      "& h2": {
        width: "100%",
      },
      "& p": {
        width: "100%",
      },
    },
  },
  bodySection: {
    backgroundImage: `url(${bodySectionBg})`,
    backgroundSize: "cover",
    backgroundPosition: "top",
    paddingBottom: "300px",
    paddingTop: "260px",
    "& .container:first-child": {
      padding: "30px 0",
    },
    "& $supportBox": {
      position: "absolute",
      top: "-460px",
      "@media only screen and (max-width: 600px)": {
        top: "-800px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "500px",
      paddingBottom: "240px",
      "& .container:first-child": {
        padding: "30px 15px",
      },
    },
  },
  gridSection: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    rowGap: "24px",
    marginTop: "60px",
    "@media only screen and (max-width: 600px)": {
      marginTop: "40px",
    },
  },
  gridRow: {
    width: "100%",
    display: "flex",
    alignItems: "stretch",
    justifyContent: "flex-start",
    gap: "24px",
    "&.row1": {
      "& $gridCard": {
        width: "49%",
      },
    },
    "&.row2": {
      "& $gridCard": {
        width: "32%",
      },
    },
    "&.row3": {
      "& $gridCard": {
        width: "49%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  gridCard: {
    display: "flex",
    flexDirection: "column",
    width: "48%",
    padding: "24px",
    justifyContent: "space-between",
    alignItems: "flex-start",
    background: "#ffffff1a",
    borderRadius: "16px",
    opacity: "1",
    backdropFilter: "blur(30px) brightness(1)",
    transition: "0.3s ease",
    gap: "16px",
    "&:hover": {
      backdropFilter: "blur(50px) brightness(1.2)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100% !important",
    },
  },
  growingBusiness: {
    //paddingTop: "60px",
    backgroundImage: `url(${bestPracticeBg})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    paddingBottom: "300px",
    position: "relative",
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "& .body": {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "stretch",
      gap: "20px",
      flexWrap: "wrap",
      marginTop: "60px",
    },
    "& $featureContainer": {
      gap: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      "& .header": {
        width: "100%",
      },
      paddingBottom: "170px",
    },
    "& $broadcastLeftContainer": {
      width: "55%",
    },
  },
  practiceCard: {
    background: "#fff",
    borderRadius: "16px",
    padding: "24px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    gap: "24px",
    width: "30%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  partnerSlide: {
    width: "185px !important",
    "& img": {
      width: "185px",
      filter: "brightness(0.1)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "140px !important",
      marginRight: "30px !important",
      "& img": {
        width: "140px",
        filter: "brightness(0.1)",
      },
    },
  },
  partnerSlider: {
    padding: "10px 0 40px !important",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px !important",
    },
  },
  commonPageFooterSection: {
    background: "linear-gradient(90deg, #011D32 0%, #00182B 100%)",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "75%",
    "@media only screen and (max-width: 600px)": {
      top: "91%",
    },
  },
  stripSection: {
    paddingTop: "280px",
    backgroundImage: `url(${partnerSectionBackground})`,
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    "& .centerContainer": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "180px",
      "& .centerContainer": {
        textAlign: "center",
      },
    },
  },
  pointers: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
    },
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& $supportBox": {
      position: "absolute",
      top: "-410px",
      background: "linear-gradient(0deg, #208EEC 0%, #002C51 100%)",
    },
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "600px",
      paddingBottom: "40px",
      "& .container:first-child": {
        padding: "0px 15px",
      },
      "& $supportBox": {
        top: "-830px",
      },
      "& .header": {
        width: "100%",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: 0,
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0 15px",
  },
  featureSection: {
    padding: "60px 0",
    background: "#F7F1FB",
  },
  featureSectionContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "30px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  featureContainerLeft: {
    width: "50%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  featureContainerRight: {
    width: "50%",
    gap: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "& $cardPointer": {
      alignItems: "flex-start",
      "& img": {
        position: "relative",
        top: "5px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        position: "relative",
        top: "5px",
        width: "20px",
      },
    },
  },
  wpFaq: {
    // padding: "40px 0",
    "& $faqSection": {
      padding: 0,
    },
    background: "#F1FFF9",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  // testimonials: {
  //   paddingBottom: "40px",
  // },
}));

const ManufacturIndustry = () => {
  const classes = useStyles();
  const partners = [
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
  ];
  const faqs = [
    {
      question:
        "Can Pepper Cloud CRM integrate with our existing manufacturing software?",
      answer: (
        <>
          Yes, Pepper Cloud CRM offers seamless integration capabilities with
          various tools required for manufacturing businesses like inventory
          tool, quote generation tools, etc. creating a unified ecosystem for
          streamlined operations.
        </>
      ),
    },
    {
      question: " How does Pepper Cloud CRM help with production planning?",
      answer: (
        <>
          Pepper Cloud CRM integrates sales forecasts with production schedules,
          helping you align production capacity with demand and optimise
          resource allocation.
        </>
      ),
    },
    {
      question:
        "How does Pepper Cloud CRM use AI to benefit manufacturing businesses? ",
      answer: (
        <>
          Pepper Cloud CRM leverages AI for chatbots for customer support,
          automated task management, and data-driven AI insights to optimise
          processes.
        </>
      ),
    },
    {
      question:
        "How does Pepper Cloud CRM facilitate collaboration between different departments?",
      answer: (
        <>
          Pepper Cloud CRM serves as a central hub for communication, ensuring
          seamless information flow between sales, production, and customer
          service teams.
        </>
      ),
    },
    {
      question: "How secure is the data stored in Pepper Cloud CRM?",
      answer: (
        <>
          Pepper Cloud CRM employs industry-standard security measures to
          protect your data, including encryption and regular backups.
        </>
      ),
    },
    {
      question: "What are the benefits of manufacturing CRM?",
      answer: (
        <>
          Implementing a CRM in the manufacturing industry offers many benefits,
          such as managing and organizing data, streamlining sales processes,
          making data-driven decisions, and automating complex sales processes.
          Ultimately, this leads to better manufacturing operational efficiency,
          improved customer satisfaction and increased revenue.
        </>
      ),
    },
    {
      question: "How can CRM systems stimulate growth in manufacturing?",
      answer: (
        <>
          A CRM system stimulates growth in manufacturing by increasing sales
          effectiveness, optimizing production workflows, enabling data-driven
          decisions, fostering collaboration across departments, improving
          customer retention, and adapting quickly to market changes. This
          results in enhanced operational efficiency and revenue growth.
        </>
      ),
    },
  ];
  const features1 = [
    {
      icon: gridIcon1,
      alt: "",
      heading: "All-in-one Sales CRM Solution",
      desc: "Unify lead capture, workflow automation, sales pipeline management, and omnichannel support in one centralised platform.",
    },
    {
      icon: gridIcon2,
      alt: "",
      heading: "AI-powered suite",
      desc: "Respond instantly with AI chatbots. Train AI chatbot with knowledge base. Automate responses. Generate key insights with AI.",
    },
  ];
  const features2 = [
    {
      icon: gridIcon3,
      alt: "",
      heading: "Tailored for manufacturing complexity",
      desc: "Easily customise pipeline, stages, form fields, message templates, AI chatbot, and more to match manufacturing business needs.",
    },
    {
      icon: gridIcon4,
      alt: "",
      heading: "Seamless integration capabilities",
      desc: "Integrate your tech stack and other tools to effortlessly create a unified ecosystem to streamline operations and boost productivity.",
    },
    {
      icon: gridIcon5,
      alt: "",
      heading: "Sales and marketing automation",
      desc: "Automate lead capture, followups, and more with workflow automation. Empower your team with a powerful CRM system.",
    },
  ];
  const features3 = [
    {
      icon: gridIcon6,
      alt: "",
      heading: "Affordable and scalable",
      desc: "Our user-based pricing model ensures you only pay for what you need, allowing your CRM to grow alongside your business.",
    },
    {
      icon: gridIcon7,
      alt: "",
      heading: "Mobile accessibility",
      desc: "Enable your team to make informed decisions by providing easy access to critical information on-the-go with mobile app.",
    },
  ];
  const bestPractice = [
    {
      icon: bestPracticeIcon1,
      alt: "",
      heading: "Centralise your data",
      desc: " Consolidate all customer and production data in your CRM for a single source of truth.",
    },
    {
      icon: bestPracticeIcon2,
      alt: "",
      heading: "Customise to your processes",
      desc: "Tailor your CRM to match your unique manufacturing workflows and requirements.",
    },
    {
      icon: bestPracticeIcon3,
      alt: "",
      heading: "Integrate with other systems",
      desc: "Connect your CRM with ERP, inventory management, and other key software for seamless operations.",
    },
    {
      icon: bestPracticeIcon4,
      alt: "",
      heading: "Train your team thoroughly",
      desc: "Ensure all users are well-versed in the CRM's features to maximise its potential.",
    },
    {
      icon: bestPracticeIcon5,
      alt: "",
      heading: "Track customer updates",
      desc: "Keep customer profiles current to provide personalised service and accurate forecasting.",
    },
    {
      icon: bestPracticeIcon6,
      alt: "",
      heading: "Leverage automation",
      desc: "Use CRM automation features to streamline repetitive tasks and increase efficiency.",
    },
  ];
  const compareItems = [
    "Pepper Cloud CRM",
    "Salesforce",
    "Microsoft Dynamics 365",
    "Odoo CRM",
    "NetSuite CRM+",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud CRM stands out as the top choice for manufacturing businesses, offering a comprehensive solution tailored to the unique challenges of the industry. With its intuitive interface, powerful AI-driven insights, and seamless integration capabilities, Pepper Cloud empowers manufacturers to streamline operations, enhance customer relationships, and drive growth.",
      img: compareItemImg1,
      alt: "",
      features: [
        {
          title: "AI-powered suite",
          desc: "Optimise sales processes with chatbots, real-time sales assistance, and automated task management.",
        },
        {
          title: "Customisable workflow",
          desc: "Adapt the CRM to fit your specific manufacturing processes and requirements.",
        },
        {
          title: "Mobile accessibility",
          desc: "Manage your business on-the-go with our iOS and Android mobile apps.",
        },
        {
          title: "Omnichannel support",
          desc: "Centralise customer interactions across various platforms, including email and social media.",
        },
        {
          title: "Sales forecasting",
          desc: "Utilise data analytics to predict sales trends and adjust strategies accordingly.",
        },
        {
          title: "Affordable pricing",
          desc: "Leverage our user-based pricing model, scaling your CRM as your business grows.",
        },
      ],
    },
    {
      title: "Salesforce Manufacturing Cloud",
      desc: "Salesforce Manufacturing Cloud offers a robust CRM solution designed for the manufacturing sector. It provides comprehensive tools for managing sales, service, and operations, with a focus on improving visibility across the entire manufacturing process.",
      img: compareItemImg2,
      alt: "",
      features: [
        {
          title: "Account-based forecasting",
          desc: "Design and send targeted campaigns to prospective students.",
        },
        {
          title: "Product and pricing management",
          desc: "Streamline complex product configurations and pricing structures.",
        },
        {
          title: "Einstein Analytics",
          desc: " Leverage AI-powered insights for data-driven decision making.",
        },
        {
          title: "Community Cloud",
          desc: "Collaborate effectively with partners and distributors.",
        },
      ],
    },
    {
      title: "Microsoft Dynamics 365 for Manufacturing",
      desc: " Microsoft Dynamics 365 for Manufacturing integrates CRM functionality with ERP capabilities, offering a unified platform for managing manufacturing operations, sales, and customer service.",
      img: compareItemImg3,
      alt: "",
      features: [
        {
          title: "Mixed reality tools",
          desc: "Utilise HoloLens for remote assistance and training.",
        },
        {
          title: "IoT integration",
          desc: "Connect and monitor manufacturing equipment for predictive maintenance.",
        },
        {
          title: "Supply chain management",
          desc: "Optimise inventory and logistics with real-time insights.",
        },
        {
          title: "AI-driven insights",
          desc: "Make informed decisions with advanced analytics and forecasting.",
        },
      ],
    },
    {
      title: "Odoo CRM",
      desc: "Odoo CRM is an open-source solution that offers flexibility and customisation for manufacturing businesses. It provides a range of integrated applications to manage various aspects of manufacturing operations.",
      img: compareItemImg4,
      alt: "",
      features: [
        {
          title: "Manufacturing resource planning",
          desc: "Efficiently plan and schedule production activities.",
        },
        {
          title: "Quality control",
          desc: "Implement quality checks throughout the manufacturing process.",
        },
        {
          title: "Inventory management",
          desc: "Track raw materials and finished products in real-time.",
        },
        {
          title: "Open-source flexibility",
          desc: "Customise the CRM to fit specific manufacturing needs.",
        },
      ],
    },
    {
      title: "NetSuite CRM+",
      desc: "NetSuite CRM+ offers a cloud-based solution that combines CRM functionality with ERP capabilities, providing a comprehensive platform for manufacturing businesses.",
      img: compareItemImg5,
      alt: "",
      features: [
        {
          title: "Order management",
          desc: "Streamline the entire order-to-cash process.",
        },
        {
          title: "360-degree customer view",
          desc: "Get a complete picture of customer interactions and transactions.",
        },
        {
          title: "Incentive management",
          desc: "Design and manage sales compensation plans.",
        },
        {
          title: "Partner relationship management",
          desc: "Collaborate effectively with channel partners and distributors.",
        },
      ],
    },
  ];
  const industryFeature = [
    {
      title: "Determine Your Manufacturing Needs",
      desc: "Pinpoint the distinct challenges and requirements of your manufacturing operations.",
    },
    {
      title: "Evaluate CRM Integration",
      desc: "Verify that the CRM integrates smoothly with your existing manufacturing software.",
    },
    {
      title: "Look for Industry-Specific Tools",
      desc: "Search for features tailored to manufacturing, such as product customization and supply chain oversight.",
    },
    {
      title: "Examine CRM Insights",
      desc: "Opt for a CRM that provides in-depth analysis to inform data-driven business decisions.",
    },
    {
      title: "Emphasize CRM Usability",
      desc: "Select a CRM that is user-friendly for easy implementation and daily use.",
    },
  ];
  const [activeAccordian, setActiveAccordian] = useState(0);
  const [activeCompare, setActiveCompare] = useState("#section0");
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  return (
    <main>
      <SEO
        title={
          "Best CRM Software for Manufacturing Business in 2024 | Pepper Cloud"
        }
        pathname={"https://peppercloud.com/whatsapp-crm/"}
        keywords="crm with whatsapp integration, crm whatsapp integration, whatsapp integration, WhatsApp-enabled CRM"
        description={
          "Pepper Cloud is the best manufacturing CRM software, designed to streamline daily operations and optimize sales processes for manufacturing industries and businesses."
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is manufacturing CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Manufacturing CRM helps businesses manage customer interactions, track production, and improve service across various manufacturing processes.",
                },
              },
              {
                "@type": "Question",
                name: "Why do you need a special CRM for your manufacturing business?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Manufacturing CRM helps tackle challenges like production planning, inventory management, and supply chain optimization, enhancing operational efficiency and customer satisfaction.",
                },
              },
              {
                "@type": "Question",
                name: "Is it worth investing in a CRM if I'm a small manufacturing business?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM helps small manufacturing businesses streamline production, enhance customer service, and make data-driven decisions, driving growth and profitability.",
                },
              },
              {
                "@type": "Question",
                name: "Can Pepper Cloud help with production planning?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud manufacturing CRM integrates sales forecasts with production schedules, helping you align production capacity with demand and optimize resource allocation.",
                },
              },
              {
                "@type": "Question",
                name: "How does Pepper Cloud support multi-channel manufacturing?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud manufacturing CRM offers omnichannel capabilities, managing sales and customer interactions across various manufacturing channels for a unified view.",
                },
              },
            ],
          },
        ]}
      />
      <section className={classes.heroSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h1
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-18"
              style={{ color: "#9E5AD5" }}
            >
              Manufacturing industry
            </motion.h1>
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 color-black1"
            >
              Best CRM for manufacturing business
            </motion.h2>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-inter-regular font-18 color-black2 mt10"
              //   style={{ color: "#A2BED3" }}
            >
              Streamlines operations, boosts productivity, and drives sales
              growth with top AI-powered CRM for manufacturing businesses. Get a
              complete overview of your customers and close deals faster.
            </motion.p>
            <div className={classes.listContainer}>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  360-degree view of business
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Seamless workflow automation
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  End-to-end customer journey
                </p>
              </div>
            </div>
            <div className="buttonContaienr mt40">
              <Link className="primaryButton font-20 font-wix-medium font-white">
                Book a free demo
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.bodySection}>
        <div className="container">
          <motion.div
            initial={{ opacity: 1, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={classes.supportBox}
            // style={{ background: point.background }}
          >
            <div className={classes.broadcastLeftContainer}>
              <p className="font-40 font-wix-regular font-white">
                What is a manufacturing CRM?
              </p>
              <p
                className="font-18 font-inter-regular"
                style={{ color: "#fff" }}
              >
                A manufacturing CRM is a specialised software designed to help
                manufacturing businesses manage their customer interactions,
                sales processes, and operational workflows more effectively. It
                centralises customer data, automates key processes, and provides
                valuable insights to optimise production, sales, and customer
                service.
              </p>
              <div className={classes.pills}>
                <div className={classes.pill}>
                  <LazyImage
                    source={whiteCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    AI-powered
                  </p>
                </div>
                <div className={classes.pill}>
                  <LazyImage
                    source={whiteCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    WhatsApp capabilities
                  </p>
                </div>
                <div className={classes.pill}>
                  <LazyImage
                    source={whiteCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    Easy to use
                  </p>
                </div>
                <div className={classes.pill}>
                  <LazyImage
                    source={whiteCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    24/7 Local support
                  </p>
                </div>
                <div className={classes.pill}>
                  <LazyImage
                    source={whiteCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    No hidden charges
                  </p>
                </div>
              </div>
            </div>
            <div className={classes.broadcastRightContainer}>
              <LazyImage
                source={meaningImg}
                alt={"Benefits of WhatsApp link generator"}
                className={classes.broadcastImg}
              />
            </div>
          </motion.div>
        </div>
        <div className="container">
          <div className={classes.experienceContainerHeader}>
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              Why Pepper Cloud is best CRM for manufacturing business
            </motion.h2>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-inter-regular font-18"
              style={{ color: "#A2BED3" }}
            >
              Pepper Cloud, an AI-powered WhatsApp Sales CRM, helps
              manufacturing companies to forecast sales, streamline operations,
              track productivity, and boost growth.
            </motion.p>
          </div>
          <div className={classes.gridSection}>
            <div className={clsx(classes.gridRow, "row1")}>
              {features1.map((feature) => (
                <div className={classes.gridCard}>
                  <img src={feature.icon} alt={feature.alt} />
                  <p className="font-wix-semibold font-24 font-white">
                    {feature.heading}
                  </p>
                  <p
                    className="font-16 font-wix-medium"
                    style={{ color: "#C0CFDD" }}
                  >
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
            <div className={clsx(classes.gridRow, "row2")}>
              {features2.map((feature) => (
                <div className={classes.gridCard}>
                  <img src={feature.icon} alt={feature.alt} />
                  <p className="font-wix-semibold font-24 font-white">
                    {feature.heading}
                  </p>
                  <p
                    className="font-16 font-wix-medium"
                    style={{ color: "#C0CFDD" }}
                  >
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
            <div className={clsx(classes.gridRow, "row3")}>
              {features3.map((feature) => (
                <div className={classes.gridCard}>
                  <img src={feature.icon} alt={feature.alt} />
                  <p className="font-wix-semibold font-24 font-white">
                    {feature.heading}
                  </p>
                  <p
                    className="font-16 font-wix-medium"
                    style={{ color: "#C0CFDD" }}
                  >
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className={classes.compareSection}>
        <div className="container">
          <motion.div
            initial={{ opacity: 1, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={classes.supportBox}
            // style={{ background: point.background }}
          >
            <div className={classes.broadcastLeftContainer}>
              <p className="font-40 font-wix-regular font-white">
                Why do you need manufacturing CRM?
              </p>
              <div className={classes.pointers}>
                <div className={classes.cardPointer}>
                  <LazyImage
                    source={whiteCheckCircle}
                    className={classes.pointerImg}
                    alt={"pointer"}
                  />
                  <p className="font-inter-regular font-18 font-white">
                    Personalise conversations: With customer data at your
                    fingertips, you can provide customised service, anticipate
                    needs, and more.
                  </p>
                </div>
                <div className={classes.cardPointer}>
                  <LazyImage
                    source={whiteCheckCircle}
                    className={classes.pointerImg}
                    alt={"pointer"}
                  />
                  <p className="font-inter-regular font-18 font-white">
                    Optimise production planning: Sales forecasts within
                    manufacturing CRM help you align production with demand.
                  </p>
                </div>
                <div className={classes.cardPointer}>
                  <LazyImage
                    source={whiteCheckCircle}
                    className={classes.pointerImg}
                    alt={"pointer"}
                  />
                  <p className="font-inter-regular font-18 font-white">
                    Improve supply chain management: Keep track of suppliers,
                    inventory levels, and lead times in one place.
                  </p>
                </div>
                <div className={classes.cardPointer}>
                  <LazyImage
                    source={whiteCheckCircle}
                    className={classes.pointerImg}
                    alt={"pointer"}
                  />
                  <p className="font-inter-regular font-18 font-white">
                    Boost team collaboration: Facilitate seamless communication
                    between sales, production, and customer service teams.
                  </p>
                </div>
              </div>
            </div>
            <div className={classes.broadcastRightContainer}>
              <LazyImage
                source={benifitImg}
                alt={"Benefits of WhatsApp link generator"}
                className={classes.broadcastImg}
              />
            </div>
          </motion.div>
        </div>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-black1"
            >
              5 best CRM for manufacturing business in 2025
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    href={`#section${index}`}
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` && "font-wix-bold"
                    )}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-40 font-wix-semibold font-black1"
                  >
                    {data.title}
                  </h3>
                  <p
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-inter-regular font-18 font-black1"
                  >
                    {data.desc}
                  </p>
                  <img src={data.img} className="productImage" alt={data.alt} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                      >
                        <div className={classes.header}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            src={downArrow}
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-inter-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className={classes.featureSection}>
        <div className="container">
          <div className={classes.featureSectionContainer}>
            <div className={classes.featureContainerLeft}>
              <LazyImage source={featureSectionImg} width={"100%"} alt={""} />
            </div>
            <div className={classes.featureContainerRight}>
              <p className="font-wix-medium font-40 color-black1">
                How to choose the best CRM for manufacturing business
              </p>
              <div className={classes.pointers}>
                {industryFeature.map((point) => (
                  <div className={classes.cardPointer}>
                    <LazyImage source={darkGreenCheck} alt={"pointer"} />
                    <p className="font-18 font-inter-regular color-black1">
                      {point.title}: {point.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.growingBusiness}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Manufacturing CRM: Best practices
            </motion.h2>
          </div>
          <div className="body">
            {bestPractice.map((practice) => (
              <div className={classes.practiceCard}>
                <img src={practice.icon} alt={practice.alt} />
                <p className="font-wix-semibold font-24 font-black1">
                  {practice.heading}
                </p>
                <p className="font-wix-medium font-16 font-black1">
                  {practice.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className={classes.absoulteCard}>
          <TruestedSection background={true} />
        </div>
      </section>
      <section className={classes.stripSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h3
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-24 font-black1"
            >
              Best CRM with WhatsApp integration - Trusted by SMEs globally
            </motion.h3>
          </div>
        </div>
        <Swiper
          className={classes.partnerSlider}
          slidesPerView="auto"
          spaceBetween={60}
          loop={true}
          speed={3000}
          modules={[Autoplay]}
          allowTouchMove={false}
          autoplay={{
            delay: 100,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 20,
            },
            // For larger screens (desktop)
            768: {
              freeMode: false,
              autoplay: {
                delay: 100,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              },
              speed: 3000,
              loop: true,
              allowTouchMove: true,
            },
          }}
        >
          {partners.map((partner) => (
            <SwiperSlide className={classes.partnerSlide}>
              <img src={partner.icon} alt={partner.alt} />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <div className={classes.testimonials}>
        <TestimonialSlider
          noButton={true}
          heading={"Real stories. Real results."}
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
        />
      </div>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#F1FFF9"}
          heading={"FAQs - Best CRM for manufacturing business"}
          faqs={faqs}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Connect, track, and succeed with the all-in-one CRM solution
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/"
            >
              Book a free demo
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ManufacturIndustry;
